export default function generateCsv(
  data: Record<string, string | number>[],
  reportName: string,
  header?: (string | number)[][],
  footer?: (string | number)[][],
) {
  const values =
    data?.map((item) =>
      Object.values(item).map((cur) =>
        typeof cur === 'string' ? `"${cur}"` : cur,
      ),
    ) || [];
  const content = [Object.keys(data?.at(0) || {}), ...values];
  if (header) {
    content.unshift(
      ...header.map((items) =>
        items.map((item) => (typeof item === 'string' ? `"${item}"` : item)),
      ),
    );
  }
  if (footer) {
    content.push(
      ...footer.map((items) =>
        items.map((item) => (typeof item === 'string' ? `"${item}"` : item)),
      ),
    );
  }
  const csvContent = content.map((e) => e.join(';')).join('\n');
  const utf8BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([utf8BOM, csvContent], {
    type: 'text/csv; charset=UTF-8',
  });
  const csvURL = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = csvURL;
  link.download = `${reportName}.csv`;
  link.click();
  window.URL.revokeObjectURL(csvURL);
  link.remove();
}
